import { Tooltip } from "@mui/material";
import { useMemo } from "react";
import { formatEllipsis } from "utils/formatString";

const OverflowText = ({
  text,
  maxChar = 30,
  textClassName = "overflow-text",
}) => {
  const trimmedText = useMemo(
    () => formatEllipsis(text, maxChar),
    [text, maxChar],
  );
  const showTootlip = useMemo(() => {
    const ellipsisChar = trimmedText?.substr(
      trimmedText?.length >= 3 ? trimmedText?.length - 3 : 0,
      trimmedText?.length,
    );
    const isEllipsis = text?.length > maxChar && ellipsisChar === "...";
    return isEllipsis;
  }, [maxChar, text, trimmedText]);
  return (
    <Tooltip title={text} disableHoverListener={!showTootlip}>
      <p className={textClassName}>{trimmedText}</p>
    </Tooltip>
  );
};

export default OverflowText;
